import { createClient } from '@supabase/supabase-js';
import { createSupabaseFetch } from '../utils/fetchUtils';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Enhanced error checking and logging
if (!supabaseUrl || !supabaseAnonKey) {
  const errorMessage = `
❌ SUPABASE CONFIGURATION ERROR ❌

Missing environment variables:
- VITE_SUPABASE_URL: ${supabaseUrl ? '✓ Present' : '❌ Missing'}
- VITE_SUPABASE_ANON_KEY: ${supabaseAnonKey ? '✓ Present' : '❌ Missing'}

To fix this:
1. Create a .env file in your project root
2. Add these lines to your .env file:
   VITE_SUPABASE_URL=your_supabase_project_url
   VITE_SUPABASE_ANON_KEY=your_supabase_anon_key
3. Restart your development server (npm run dev)

You can find these values in your Supabase dashboard:
Settings → API → Project URL and Project API keys
  `;
  
  console.error(errorMessage);
  throw new Error('Supabase configuration is missing. Please check your .env file.');
}

// Validate URL format
if (!supabaseUrl.startsWith('https://') || !supabaseUrl.includes('supabase.co')) {
  console.error('❌ Invalid Supabase URL format:', supabaseUrl);
  throw new Error('Invalid Supabase URL format. Expected format: https://your-project.supabase.co');
}

// Create Supabase client with enhanced error handling
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false
  },
  global: {
    fetch: createSupabaseFetch(30000), // 30 second timeout
    headers: {
      'X-Client-Info': 'ngap-kine-app'
    }
  }
});

// Test connection function
export async function testSupabaseConnection(): Promise<{ success: boolean; error?: string }> {
  try {
    console.log('🔍 Testing Supabase connection...');
    console.log('📡 Supabase URL:', supabaseUrl);
    console.log('🔑 Anon Key (first 10 chars):', supabaseAnonKey.substring(0, 10) + '...');
    
    const { error } = await supabase
      .from('ngap_cotations')
      .select('ID')
      .limit(1);
    
    if (error) {
      console.error('❌ Supabase connection test failed:', error);
      return { 
        success: false, 
        error: `Database error: ${error.message}` 
      };
    }
    
    console.log('✅ Supabase connection test successful');
    return { success: true };
    
  } catch (err) {
    console.error('❌ Network error during connection test:', err);
    return { 
      success: false, 
      error: err instanceof Error ? err.message : 'Unknown network error' 
    };
  }
}